module.exports = __webpack_public_path__ + "img/director-work-icon6.0b62ae19.png";